module.exports = __webpack_public_path__ + "js/skins/ui/oxide/skin.mobile.css";